/**
 * Splits a dollar amount into whole dollars and cents
 * Handles floating point precision issues by rounding to nearest cent first
 * @param amount - The dollar amount to split
 * @returns Object containing dollars and cents (0-99)
 */
export function splitDollarsAndCents(amount: number): {
  dollars: number
  cents: number
} {
  const absAmount = Math.abs(amount)

  // Round to nearest cent to handle floating point precision
  const roundedAmount = Math.round(absAmount * 100) / 100
  const dollars = Math.floor(roundedAmount)
  const cents = Math.round((roundedAmount - dollars) * 100)

  return { dollars, cents }
}
